import { memo } from "react";
import { useAppSelector } from "Data/Redux/Store";
import "Components/ConfigLayout/System/SystemInformation/SystemInformation.less";
import { selectSystemInformation } from "Data/Redux/Slices/Settings/System/Information";
import { Card, SettingsLayout } from "@clintonelec/react-storybook";

function SystemInformation() {
	const systemInformation = useAppSelector(selectSystemInformation);
	const {
		model, firmwareVersion, serialNumber, sdCardCapacity, sdCardUsage, macAddress, ipAddress, gateway, subnetMask,
		dns1, dns2, httpPort, httpsPort, rtspPort
	} = systemInformation;

	return (
		<div className="settings-form system-information-settings">
			<SettingsLayout.ScrollableContainer>
				<Card size="small" title="System Information">
					<div className="form-row info-row">
						<span>Model</span>
						<p>{ model }</p>
					</div>
					<div className="form-row info-row">
						<span>F/W Version</span>
						<p>{ firmwareVersion }</p>
					</div>
					<div className="form-row info-row">
						<span>Serial Number</span>
						<p>{ serialNumber }</p>
					</div>
					<div className="form-row info-row">
						<span>SD Card Capacity</span>
						<p>{ sdCardCapacity } GB</p>
					</div>
					<div className="form-row info-row">
						<span>SD Card Usage</span>
						<p>{ sdCardUsage } GB</p>
					</div>
					<div className="form-row info-row">&nbsp;</div>
					<div className="form-row info-row">
						<span>MAC Address</span>
						<p>{ macAddress }</p>
					</div>
					<div className="form-row info-row">
						<span>IP Address</span>
						<p>{ ipAddress }</p>
					</div>
					<div className="form-row info-row">
						<span>Gateway</span>
						<p>{ gateway }</p>
					</div>
					<div className="form-row info-row">
						<span>Subnet Mask</span>
						<p>{ subnetMask }</p>
					</div>
					<div className="form-row info-row">
						<span>DNS Address 1</span>
						<p>{ dns1 }</p>
					</div>
					<div className="form-row info-row">
						<span>DNS Address 2</span>
						<p>{ dns2 }</p>
					</div>
					<div className="form-row info-row">
						<span>HTTP Port</span>
						<p>{ httpPort }</p>
					</div>
					<div className="form-row info-row">
						<span>HTTPS Port</span>
						<p>{ httpsPort }</p>
					</div>
					<div className="form-row info-row">
						<span>RTSP Port</span>
						<p>{ rtspPort }</p>
					</div>
				</Card>
			</SettingsLayout.ScrollableContainer>
		</div>
	);
}

export default memo(SystemInformation);
